<template>
  <div class="rule-group border p-4 rounded mb-2">
    <ul>
      <li v-for="(filter, index) in filters.filters" :key="index" class="mb-2">
        <div v-if="!filter.filters" class="flex items-center gap-2">
          <!-- <input v-model="filter.indexTypeSub" placeholder="子類型" class="input-box" />
          <input v-model="filter.indexType" placeholder="主類型" class="input-box" /> -->
          <!-- <select v-model="filter.indexType" class="select-box" @change="updateOperator(filter)">
            <option value="LIFETIME_CPA">CPA</option>
            <option value="LIFETIME_ROAS">ROAS</option>
            <option value="LIFETIME_CTR">CTR</option>
            <option value="LIFETIME_SPEND">花費</option>
            <option value="DAY">走期天數</option>
            <option value="LIFETIME_ACTION">成果數</option>
          </select> -->
          <Dropdown 
            v-model="filter.indexType"
            :options="indexTypeOptions"
            optionLabel="label"
            optionValue="value"
            class="dropdown-box leading-3"
            @change="updateOperator(filter)"
            placeholder="選擇主類型"
          />
          <!-- <select v-model="filter.indexTypeSub" class="select-box" :disabled="filter.indexType === 'DAY'" @change="updateOperator">
            <option value="7D">近7天</option>
            <option value="LIFETIME">整個走期</option>
            <option value="2X">兩周</option>
          </select> -->
          <Dropdown 
            v-model="filter.indexTypeSub"
            :options="indexTypeSubOptions"
            optionLabel="label"
            optionValue="value"
            class="dropdown-box leading-3"
            :disabled="filter.indexType === 'DAY'"
            @change="updateOperator"
            placeholder="選擇子類型"
          />
          <!-- <select v-model="filter.operator" class="select-box" @change="updateOperator">
            <option value="GREATER_THAN">大於</option>
            <option value="GREATER_THAN_EQUAL">大於等於</option>
            <option value="EQUAL">等於</option>
            <option value="LESS_THAN_EQUAL">小於等於</option>
            <option value="LESS_THAN">小於</option>
          </select> -->
          <Dropdown 
            v-model="filter.operator"
            :options="operatorOptions"
            optionLabel="label"
            optionValue="value"
            class="dropdown-box leading-3"
            @change="updateOperator"
            placeholder="選擇運算符"
          />
          <input v-model="filter.value" type="text" placeholder="值" class="input-box leading-7 w-40"  @change="updateOperator"/>
          <button @click="removeFilter(index)" class="btn btn-danger text-sm">🗑️</button>
        </div>

        <!-- 條件組（遞迴） -->
        <div v-else>
          <!-- 条件组标题和删除按钮 -->
          <div class="items-center justify-between bg-gray-200 px-2 py-1 rounded h-11 text-right">
            <button
              @click="removeFilter(index)"
              class="btn btn-danger text-xs"
            >
              删除條件組
            </button>
          </div>

          <RuleForwardGroup
            :filters="filter"
            @changeData="updateChildFilters(index, $event)"
            :canAddCondition="canAddCondition"
            class="rounded-b border-l-2 pl-4"
          />
          <!-- 如果條件組為空，顯示刪除按鈕 -->
          <!-- <div v-if="!filter.filters || filter.filters.length === 0" class="text-center mt-2">
            <button @click="removeFilter(index)" class="btn btn-danger">刪除條件組</button>
          </div> -->
        </div>

        <!-- 邏輯選擇器 -->
        <div v-if="index < filters.filters.length - 1" class="logic-selector my-2">
          <!-- <select v-model="filters.operator" class="select-box" @change="updateOperator">
            <option value="AND">AND</option>
            <option value="OR">OR</option>
          </select> -->
          <Dropdown 
            v-model="filters.operator"
            :options="logicOptions"
            optionLabel="label"
            optionValue="value"
            class="dropdown-box leading-3"
            @change="updateOperator"
            placeholder="選擇邏輯"
          />
        </div>
      </li>
    </ul>

    <!-- <div v-if="canAddCondition" class="mt-2"> -->
    <div class="mt-2">
      <button @click="addCondition" class="btn btn-primary">新增條件</button>
      <button @click="addGroup" class="btn btn-secondary ml-2">新增條件組</button>
    </div>
  </div>
</template>

<script>
import Dropdown from 'primevue/dropdown';
import { toRaw } from 'vue';

export default {
  name: "RuleForwardGroup",
  components: {
    Dropdown,
  },
  props: {
    filters: Object,
    conditionCount: Number,
    canAddCondition: Boolean
  },
  data() {
    return {
      calculatedConditionCount: 0,
      indexTypeOptions: [
        { label: 'CPA', value: 'LIFETIME_CPA' },
        { label: 'ROAS', value: 'LIFETIME_ROAS' },
        { label: 'CTR', value: 'LIFETIME_CTR' },
        { label: '花費', value: 'LIFETIME_SPEND' },
        { label: '走期天數', value: 'DAY' },
        { label: '成果數', value: 'LIFETIME_ACTION' },
      ],
      indexTypeSubOptions: [
        { label: '近7天', value: '7D' },
        { label: '整個走期', value: 'LIFETIME' },
        { label: '兩周', value: '2X' },
      ],
      operatorOptions: [
        { label: '大於', value: 'GREATER_THAN' },
        { label: '大於等於', value: 'GREATER_THAN_EQUAL' },
        { label: '等於', value: 'EQUAL' },
        { label: '小於等於', value: 'LESS_THAN_EQUAL' },
        { label: '小於', value: 'LESS_THAN' },
      ],
      logicOptions: [
        { label: 'AND', value: 'AND' },
        { label: 'OR', value: 'OR' },
      ],
    }
  },
  methods: {
    // 新增條件
    addCondition() {
      this.filters.filters ??= [];
      const newCondition = {
        indexTypeSub: "",
        indexType: "",
        operator: "GREATER_THAN_EQUAL",
        value: null,
      };
      this.filters.filters.push(newCondition);
      this.emitUpdate();
    },

    // 新增條件組
    addGroup() {
      if (!this.filters.filters) {
        this.filters.filters = [];
      }

      const newGroup = {
        operator: "AND"
      };

      const updatedFilters = [...this.filters.filters, newGroup];
      updatedFilters[updatedFilters.length - 1].filters = []; // 為新組添加空的 filters

      this.emitUpdate(updatedFilters);
    },

    // 刪除條件
    removeFilter(index) {
      this.filters.filters.splice(index, 1);
      this.emitUpdate();
    },

    // 更新子組件的過濾器
    updateChildFilters(index, updatedFilters) {
      this.filters.filters[index] = updatedFilters;
      // this.cleanEmptyGroups(this.filters);
      this.emitUpdate();
    },

    // 用於清理空的組，避免無效的條件組被保留
    // cleanEmptyGroups(filters) {
    //   if (filters.filters) {
    //     filters.filters = filters.filters.filter((filter) => {
    //       // 如果是條件組，遞迴清理空組
    //       if (filter.filters) {
    //         this.cleanEmptyGroups(filter);
    //         return filter.filters.length > 0; // 只保留非空條件組
    //       }
    //       return true;
    //     });
    //   }
    // },

    linkIndexTypeSub(filter) {
      const indexTypeSubMap = {
        DAY: "LIFETIME",
        LIFETIME_SPEND: "LIFETIME",
        LIFETIME_ACTION: "LIFETIME",
        LIFETIME_CPA: "7D",
        LIFETIME_ROAS: "7D",
        LIFETIME_CTR: "7D",
      };

      if (filter.indexType in indexTypeSubMap) {
        filter.indexTypeSub = indexTypeSubMap[filter.indexType];
      }

      // 禁用處理
      if (filter.indexType === "DAY") {
        filter.indexTypeSub = "LIFETIME";
      }
    },

    updateOperator(filter) {
      this.linkIndexTypeSub(filter);
      // 單獨更新 operator，不會重設 filters
      this.$emit("changeData", { ...this.filters });
    },

    // 發送更新事件到父組件
    emitUpdate(updatedFilters = this.filters.filters) {
      const updateData = { ...this.filters, filters: updatedFilters };
      this.$emit("changeData", updateData); // 將更新資料發送給父組件

      // 更新條件數量
      // this.$emit("update:conditionCount", this.countConditions(updatedFilters));
    },

    // 統計條件數量
    countConditions(filters) {
      let count = 0;
      const countRecursive = (filtersList) => {
        filtersList.forEach((filter) => {
          if (filter.filters && Array.isArray(filter.filters)) {
            countRecursive(filter.filters); // 遞迴處理子組
          } else {
            count++; // 增加條件數量
          }
        });
      };
      countRecursive(filters);
      return count;
    },
  },
};
</script>

<style scoped>
.rule-group {
  @apply border border-gray-300 rounded-md p-4 bg-gray-50;
}

.input-box {
  @apply border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400;
}

.select-box {
  @apply border border-gray-300 rounded px-2 py-1 bg-white focus:outline-none focus:ring-2 focus:ring-blue-400;
}

.btn {
  @apply px-4 py-2 rounded text-white font-medium focus:outline-none transition;
}

.btn-primary {
  @apply bg-blue-500 hover:bg-blue-600;
}

.btn-secondary {
  @apply bg-gray-500 hover:bg-gray-600;
}

.btn-danger {
  @apply bg-red-500 hover:bg-red-600;
}

.logic-selector {
  @apply items-center justify-center;
}

.dropdown-box {
  @apply w-40 border border-gray-300 rounded px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-400;
}
</style>
